import React from 'react';
import './DeleteConfirmModal.css';

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, title, message, itemName, loading = false }) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <div className="delete-modal-overlay" onClick={onClose}>
      <div className="delete-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="delete-modal-icon">⚠️</div>
        <h2 className="delete-modal-title">{title}</h2>
        <p className="delete-modal-message">
          {message}
        </p>
        {itemName && (
          <div className="delete-modal-item-name">
            <strong>{itemName}</strong>
          </div>
        )}
        <p className="delete-modal-warning">
          Cette action est irréversible.
        </p>
        <div className="delete-modal-actions">
          <button
            className="delete-modal-cancel"
            onClick={onClose}
            disabled={loading}
          >
            Annuler
          </button>
          <button
            className="delete-modal-confirm"
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? 'Suppression...' : 'Supprimer'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;

